<template>
  <div class="create_wrapper fadeIn">
    <!-- Start Breadcrumb -->
    <Breadcrumb :items="items" />
    <!-- End Breadcrumb -->

    <div class="custom_card">
      <div class="card-header">
        <h4 class="card-title">{{ $t("edit") }}</h4>
      </div>

      <!-- ==== Start Form ==== -->
      <form @submit.prevent="validateCreateForm">
        <div class="container">
          <div class="row justify-content-between">
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <input
                  @keypress="isArabic"
                  type="text"
                  class="form-control"
                  @input="helper_checkIfInputIsEmpty"
                  v-model.trim="data.ar.title"
                />
                <label for="name_input" class="form-label">
                  {{ $t("forms.labels.name_ar") }}
                </label>
              </div>
            </div>

            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <input
                  @keypress="isEnglish"
                  type="text"
                  class="form-control"
                  @input="helper_checkIfInputIsEmpty"
                  v-model.trim="data.en.title"
                />
                <label for="name_input" class="form-label">
                  {{ $t("forms.labels.name_en") }}
                </label>
              </div>
            </div>
            <div class="col-6 py-0">
              <div class="input_wrapper top_label">
                <label for="price" class="form-label">
                  {{ $t("forms.labels.min_invites") }}
                </label>
                <input
                  type="number"
                  class="form-control"
                  v-model="data.min_invites"
                />
              </div>
            </div>
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <label class="form-label">نوع الجائزة</label>
                <multiselect
                  v-model="data.type"
                  :options="types"
                  label="name"
                  track-by="id"
                  placeholder=" "
                  :searchable="true"
                  :allow-empty="false"
                  :show-labels="false"
                ></multiselect>
              </div>
            </div>

            <div class="col-12 py-0">
              <div class="input_wrapper top_label">
                <label for="reward_value" class="form-label">
                  {{ $t("forms.labels.reward_value") }}
                </label>
                <input
                  :type="data.type.id == 'cash' ? 'number' : 'text'"
                  class="form-control"
                  v-model="data.reward_value"
                />
              </div>
            </div>
            <div class="col-6 py-0">
              <v-checkbox
                :label="$t('forms.labels.is_active')"
                v-model="data.is_active"
                color="success"
              ></v-checkbox>
            </div>
          </div>
        </div>

        <div class="buttons_wrapper">
          <button class="button_style_1" :disabled="btnIsLoading">
            {{ $t("forms.submit") }}
            <span class="btn_loader" v-if="btnIsLoading"></span>
          </button>
        </div>
      </form>
      <!-- ==== End Form ==== -->
    </div>
  </div>
</template>

<script>
export default {
  name: "Create",
  props: ["id"],

  data() {
    return {
      loading: false,
      // ========== Breadcrumbs
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: this.$t("breadcrumb.rewards.title"),
          disabled: false,
          href: "/rewards/show-all",
        },
        {
          text: this.$t("breadcrumb.rewards.edit"),
          disabled: true,
          href: "",
        },
      ],

      // ========== Loading
      btnIsLoading: false,

      // ========== create_data
      data: {
        image: null,
        ar: {
          title: null,
        },
        en: {
          title: null,
        },
        min_invites: null,
        is_active: false,
        type: null,
        reward_value: null,
      },

      // Fixed Data
      categories: [],
    };
  },

  methods: {
    uplodeImg_1(obj) {
      console.log(obj);
      this.data.image = obj;
    },
    getData() {
      this.$axios.get(`rewards/${this.id}`).then((res) => {
        const result = res.data.data;
        this.data.ar.title = result.ar.title;
        this.data.en.title = result.en.title;
        this.data.is_active = result.is_active;
        this.data.min_invites = result.min_invites;
        this.data.type = this.types.find(
          (type) => type.id == result.reward_type
        );
        this.data.reward_value = result.reward_value;
      });
    },
    // Validate Data
    validateCreateForm() {
      this.btnIsLoading = true;

      if (!this.data.ar.title) {
        this.$iziToast.error({
          timeout: 2000,
          message: this.$t("forms.validation.name_ar"),
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.en.title) {
        this.$iziToast.error({
          timeout: 2000,
          message: this.$t("forms.validation.name_en"),
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.min_invites) {
        this.$iziToast.error({
          timeout: 2000,
          message: this.$t("forms.validation.min_invites"),
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.type.id) {
        this.$iziToast.error({
          timeout: 2000,
          message: this.$t("forms.validation.type"),
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.reward_value) {
        this.$iziToast.error({
          timeout: 2000,
          message: this.$t("forms.validation.reward_value"),
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else {
        this.submitData();
        return;
      }
    },

    // Submit Data
    submitData() {
      this.btnIsLoading = true;

      const submit_data = new FormData();
      if (this.data.image) {
        submit_data.append("image", this.data.image);
      }
      submit_data.append("ar[title]", this.data.ar.title);
      submit_data.append("en[title]", this.data.en.title);
      submit_data.append("min_invites", this.data.min_invites);
      submit_data.append("reward_type", this.data.type.id);
      submit_data.append("reward_value", this.data.reward_value);
      submit_data.append("is_active", this.data.is_active ? 1 : 0);
      submit_data.append("_method", "PUT");

      this.$axios({
        method: "POST",
        url: `rewards/${this.id}`,
        data: submit_data,
      })
        .then(() => {
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("editSuccess"),
            position: "bottomRight",
          });

          this.$router.push({ path: "/rewards/show-all" });

          this.btnIsLoading = false;
        })
        .catch((err) => {
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
          this.btnIsLoading = false;
        });
    },
  },
  computed: {
    types() {
      return [
        { id: "cash", name: this.$t("forms.labels.cash") },
        { id: "gift", name: this.$t("forms.labels.gift") },
      ];
    },
  },
  created() {
    this.getData();
  },
};
</script>
